/**
 * 模块名称: 合同申请 => 选择模板时运营属性提示框
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect } from 'react'
import { Modal, Checkbox, Button, message, Icon } from 'antd'
import api from '@/api'

const OperationalTipModal = ({ visible, onClose }) => {
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (visible) {
      setChecked(false)
    }
  }, [visible])

  const handleOk = () => {
    if (!checked) {
      message.warning('请先勾选“我已知晓，不再提示”')
      return
    }
    api.getFortuneStaffTipAdd({ type: 1 }).then(res => {
      onClose(true) // 传 true 刷新模板数据
    })
  }

  const handleCancel = () => {
    onClose(false)
  }

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <b style={{ color: '#faad14', fontSize: '30px', marginRight: '10px' }}>!</b>
          提示
        </div>
      }
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="确认"
      cancelText="取消"
      width={700}
    >
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        用该合同模板申请的合同可能需要您选择以下四种运营属性中一种，请慎重选择，如后期需要修改，请在合同列表页点击图标“
        <Icon type="appstore" style={{ color: '#1890FF', fontSize: '16px' }} />” 修改。
      </p>
      <p style={{ textIndent: '2em' }}>
        a. 直销代运营　b. 渠道代运营　c. 直销自运营　d. 渠道自运营
      </p>
      <p style={{ textIndent: '2em' }}>
        1. 代运营服务类直销、代理商客户，公司提供创意搭建、数据优化运营、数据分析等服务；
      </p>
      <p style={{ textIndent: '2em' }}>
        2. 自运营类直销、代理商客户，公司仅提供账户充值服务。
      </p>
      <Checkbox checked={checked} onChange={e => setChecked(e.target.checked)}>
        我已知晓，不再提示
      </Checkbox>
    </Modal>

  )
}

export default OperationalTipModal